import { ROLE_OPTIONS } from "../../constants/Constants";
import { getStationCode } from "../../../network/NetworkUtil";
import { notifyParentOfSelectedRoles } from "../../../handler/ParentDataHandler";

export const SET_SELECTED_ROLES = "SET_SELECTED_ROLES";
export const LOAD_SELECTED_ROLES_FROM_STORAGE =
  "LOAD_SELECTED_ROLES_FROM_STORAGE";

const SELECTED_ROLES_STORAGE_KEY_PREFIX = "mySCC_selectedRoles";

// Get station-specific storage key
const getStorageKey = () => {
  const stationCode = getStationCode();
  return stationCode
    ? `${SELECTED_ROLES_STORAGE_KEY_PREFIX}_${stationCode}`
    : SELECTED_ROLES_STORAGE_KEY_PREFIX;
};

// Load initial state from localStorage or return empty array
const getInitialState = () => {
  let roles = [];

  try {
    const storageKey = getStorageKey();
    const storedRoles = localStorage.getItem(storageKey);
    if (storedRoles) {
      const parsed = JSON.parse(storedRoles);
      // Validate that stored roles are still valid
      const validRoles = parsed.filter((role) =>
        ROLE_OPTIONS.some((option) => option.value === role),
      );
      roles = validRoles;
    }
  } catch (error) {
    console.warn("Failed to load selected roles from localStorage:", error);
  }

  // If no stored roles found, check if this is first load - if so, default to first role
  // Otherwise, respect the empty selection
  if (roles.length === 0) {
    const storageKey = getStorageKey();
    const hasStorageKey = localStorage.getItem(storageKey) !== null;
    if (!hasStorageKey) {
      // First time load - default to first role
      roles = [ROLE_OPTIONS[0].value];
    }
    // If storage key exists but is empty/invalid, keep empty array
  }

  // Notify parent window of initial roles
  notifyParentOfSelectedRoles(roles);

  return roles;
};

const initialState = getInitialState();

/**
 * Reducer for selected roles with localStorage persistence
 */
export const selectedRolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_ROLES:
      // Prevent empty selection - fallback to first role if empty array is provided
      let rolesToSave = action.payload;
      if (!rolesToSave || rolesToSave.length === 0) {
        console.warn(
          "Attempted to set empty roles array, defaulting to first role",
        );
        rolesToSave = [ROLE_OPTIONS[0].value];
      }

      // Save to localStorage when roles are updated
      try {
        const storageKey = getStorageKey();
        localStorage.setItem(storageKey, JSON.stringify(rolesToSave));
      } catch (error) {
        console.warn("Failed to save selected roles to localStorage:", error);
      }
      return rolesToSave;

    case LOAD_SELECTED_ROLES_FROM_STORAGE:
      return getInitialState();

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/SelectedRolesReducer.js